import { render } from "./TripsTable.vue?vue&type=template&id=25790640"
import script from "./TripsTable.vue?vue&type=script&lang=js"
export * from "./TripsTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/reps.mlelectronics.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__